module.exports = __webpack_public_path__ + "img/head.72044626.png";